import React, { useState } from 'react'
import QaiChallengeFilterViewModel from './ViewModels/QaiChallengeFilterViewModel';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import DatesChip from '../../Filtering/DateTimeFilters/Chips/DatesChip';
import { ToggleChip } from '../../Utilities/ToggleChip';
import ClientChip from '../../Filtering/Chips/ClientChip';
import ScorecardTemplateChip from '../../Filtering/Chips/ScorecardTemplateChip';
import QaiSectionsChip from './QaiSectionsChip';
import QaiChallengeStatusChip from './QaiChallengeStatusChip';
import QaiChallengeStateChip from './QaiChallengeStateChip';

interface IQaiChallengeFilterBarProps {
    filters: QaiChallengeFilterViewModel
    setFilters: (value: any) => void;
    getChallenges: () => void;
    setOpenChallengeDialog: (value: boolean) => void;
}

export default function QaiChallengeFilterBar({ filters, setFilters, getChallenges, setOpenChallengeDialog }: IQaiChallengeFilterBarProps) {
    const [openFiltersDialog, setOpenFiltersDialog] = useState(false)

    const handleFiltersDialogOpen = () => {
        setOpenFiltersDialog(true);
    }

    const handleFiltersDialogClose = () => {
        setOpenFiltersDialog(false);
    }

    const updateFilters = (filters: QaiChallengeFilterViewModel) => {
        setFilters(filters);
    }

    const updateFilterValue = (filterName: string, value: any) => {
        setFilters({
            ...filters,
            [filterName]: value
        })
    }

    const removeFilter = (filterFlag: string, filterNames?: string[]) => {
        const filt = { ...filters };

        filt[filterFlag] = false;

        if (filterNames) {
            for (const name of filterNames) {
                if (typeof filt[name] === "string") {
                    filt[name] = "";
                } else if (Array.isArray(filt[name])) {
                    filt[name] = [];
                }
                else {
                    filt[name] = null;
                }
            }
        }

        updateFilters(filt);
    }

    const setFilterValue = (filterName: string, value: any) => {
        updateFilterValue(filterName, value);
    }

    const handleSelect = (value: string, newValue?: boolean) => {
        if (newValue === undefined) {
            setFilters(prevState => ({
                ...prevState,
                [value]: !prevState[value]
            }))
        }
        else {
            setFilters(prevState => ({
                ...prevState,
                [value]: newValue
            }))
        }
    }

    const handleDate = (value: string) => {
        const oldValue = filters[value];
        setFilters(prevState => ({
            ...prevState,
            flagThisWeek: false,
            flagLastWeek: false,
            flagThisMonth: false,
            flagLastMonth: false,
        }))
        handleSelect(value, !oldValue);
    };

    return (
        <>
            <Dialog open={openFiltersDialog} fullWidth maxWidth="sm">
                <Grid container height="100%">
                    <Grid container size={12}>
                        <Grid container size={6} spacing={0.5}>
                            <Grid size={12}>
                                <Typography>Date/Time Filters</Typography>
                            </Grid>
                            <ToggleChip selected={filters.flagThisWeek} key={filters.flagThisWeek.toString() + "flagThisWeek"} value="This Week" onSelect={handleDate} />
                            <ToggleChip selected={filters.flagLastWeek} key={filters.flagLastWeek.toString() + "flagLastWeek"} value="Last Week" onSelect={handleDate} />
                            <ToggleChip selected={filters.flagThisMonth} key={filters.flagThisMonth.toString() + "flagThisMonth"} value="This Month" onSelect={handleDate} />
                            <ToggleChip selected={filters.flagLastMonth} key={filters.flagLastMonth.toString() + "flagLastMonth"} value="Last Month" onSelect={handleDate} />
                        </Grid>
                        <Grid container spacing={0.5} size={6}>
                            <Grid size={12}>
                                <Typography>Additional Filters</Typography>
                            </Grid>
                            <ToggleChip selected={filters.flagClient} key={filters.flagClient.toString() + "flagClient"} value="Client" onSelect={handleSelect} />
                            <ToggleChip selected={filters.flagTemplate} key={filters.flagTemplate.toString() + "flagTemplate"} value="Template" onSelect={handleSelect} />
                            <ToggleChip selected={filters.flagSection} key={filters.flagSection.toString() + "flagSection"} value="Section" onSelect={handleSelect} />
                            <ToggleChip selected={filters.flagStatus} value="Status" onSelect={handleSelect} />
                            <ToggleChip selected={filters.flagStates} value="States" onSelect={handleSelect} />
                        </Grid>
                    </Grid>
                    <Grid container size={12} justifyContent="flex-end" spacing={1} marginTop={4}>
                        <Grid size={2}>
                            <Button variant="contained" fullWidth onClick={handleFiltersDialogClose}>Confirm</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Dialog>
            <Grid container justifyContent='space-between'>
                <Grid container size={8} spacing={1}>
                    <ClientChip filterFlag="flagClient" filterNames={["client"]} show={filters.flagClient} title="Client" currentSelection={filters.client} onSelect={setFilterValue} filterName="client" />
                    <DatesChip filterLabel="This Week" filterFlag="flagThisWeek" filterNames={[""]} removeFilter={removeFilter} onSelect={setFilterValue} show={filters.flagThisWeek} />
                    <DatesChip filterLabel="Last Week" filterFlag="flagLastWeek" filterNames={[""]} removeFilter={removeFilter} onSelect={setFilterValue} show={filters.flagLastWeek} />
                    <DatesChip filterLabel="This Month" filterFlag="flagThisMonth" filterNames={[""]} removeFilter={removeFilter} onSelect={setFilterValue} show={filters.flagThisMonth} />
                    <DatesChip filterLabel="Last Month" filterFlag="flagLastMonth" filterNames={[""]} removeFilter={removeFilter} onSelect={setFilterValue} show={filters.flagLastMonth} />
                    <ScorecardTemplateChip removeFilter={removeFilter} filterFlag="flagTemplate" filterNames={["template"]} show={filters.flagTemplate} title="Scorecard Template" currentSelection={filters.template} onSelect={setFilterValue} filterName="template" client={filters.client} />
                    <QaiChallengeStatusChip removeFilter={removeFilter} filterFlag="flagStatus" filterNames={["status"]} show={filters.flagStatus} title="Status" currentSelection={filters.status} onSelect={setFilterValue} filterName="status" />
                    <QaiChallengeStateChip removeFilter={removeFilter} filterFlag="flagStates" filterNames={["states"]} show={filters.flagStates} title="State" currentSelection={filters.states} onSelect={setFilterValue} filterName="states" />
                    <QaiSectionsChip filters={filters} removeFilter={removeFilter} templateName={filters.template} setFilterValue={setFilterValue} />
                    <Grid>
                        <Chip label='Select Filters' color='primary' onClick={handleFiltersDialogOpen} sx={{ marginLeft: '8px' }}></Chip>
                    </Grid>
                </Grid>
                <Grid container size={3} spacing={1} justifyContent='flex-end'>
                    <Grid>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => setOpenChallengeDialog(true)}
                        >
                            Raise a challenge
                        </Button>
                    </Grid>
                    <Grid>
                        <Button variant='contained' onClick={getChallenges}>Apply filters</Button>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}